var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MdIconModule, MdSelectModule, MdButtonModule } from '@angular/material';
import { TdPagingBarComponent } from './paging-bar.component';
export { TdPagingBarComponent } from './paging-bar.component';
var CovalentPagingModule = (function () {
    function CovalentPagingModule() {
    }
    return CovalentPagingModule;
}());
CovalentPagingModule = __decorate([
    NgModule({
        imports: [
            FormsModule,
            CommonModule,
            MdIconModule,
            MdSelectModule,
            MdButtonModule,
        ],
        declarations: [
            TdPagingBarComponent,
        ],
        exports: [
            TdPagingBarComponent,
        ],
    })
], CovalentPagingModule);
export { CovalentPagingModule };
//# sourceMappingURL=paging.module.js.map


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/@covalent/core/paging/paging.module.js
// module id = ../../../../@covalent/core/paging/paging.module.js
// module chunks = 4